import { ConcreteEncodable } from "./ConcreteEncodable";

import { CustomFieldImplEncoder } from "../../encoder/CustomFieldImplEncoder";

import * as CubiqTS from "../../index";
import { CustomField } from "../CustomField";

export class CustomFieldImpl extends ConcreteEncodable implements CustomField {
  public static enType: string = "com.bcdfx.model.event.lifecycle.CustomFieldImpl";

  /*FID=1*/
  public fieldId: string;
  /*FID=2*/
  public displayName: string;
  /*FID=3*/
  public isNullableFg: boolean;
  /*FID=4*/
  public defaultValueId: string;
  /*FID=5*/
  public isEnabledFg: boolean;
  /*FID=6*/
  public domainValues: Array<string> | null = null;
  /*FID=7*/
  public freeFormatTxtFg: boolean;
  /*FID=8*/
  public showOnNewModifyOrderUiFg: boolean;
  /*FID=9*/
  public maxLen: number;
  /*FID=10*/
  public disableOnPartFillFg: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CustomFieldImplEncoder.Instance;
    this.setEncodableType(CustomFieldImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "CustomFieldImpl[" +
      "fieldId=" +
      this.fieldId +
      "displayName=" +
      this.displayName +
      "isNullableFg=" +
      this.isNullableFg +
      "defaultValueId=" +
      this.defaultValueId +
      "isEnabledFg=" +
      this.isEnabledFg +
      "domainValues=" +
      this.domainValues +
      "freeFormatTxtFg=" +
      this.freeFormatTxtFg +
      "showOnNewModifyOrderUiFg=" +
      this.showOnNewModifyOrderUiFg +
      "maxLen=" +
      this.maxLen +
      "disableOnPartFillFg=" +
      this.disableOnPartFillFg +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
